import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import 'react-modal-video/scss/modal-video.scss' ;
// import { Modal } from "react-bootstrap";
import './styles.scss'

const MEDIA_STAGE_EXTRA_HEIGHT = 72;
const MEDIA_CAROUSEL_DELAY = 5000;
const MEDIA_RIPPLE_COUNT = 5;

SliderItem.propTypes = {
    item : PropTypes.object,
};

function getMediaType(mediaSrc) {
    if (mediaSrc?.match(/\.mp4($|\?)/i)) return 'video';
    if (mediaSrc?.match(/\.gif($|\?)/i)) return 'gif';
    return 'image';
}

function SliderItem(props) {
    const {item} = props;
    const mediaItems = item.mediaItems?.length
        ? item.mediaItems
        : [{ media: item.media || item.img, mediaType: item.mediaType }];
    const [activeMediaIndex, setActiveMediaIndex] = useState(0);
    const activeMedia = mediaItems[activeMediaIndex] || mediaItems[0];
    const mediaSrc = activeMedia.media;
    const mediaType = activeMedia.mediaType || getMediaType(mediaSrc);
    const mediaFitClass = activeMedia.mediaFit ? `media-stage--${activeMedia.mediaFit}` : '';
    const contentRef = useRef(null);
    const [mediaHeight, setMediaHeight] = useState(null);
    const mediaStageHeight = mediaHeight ? mediaHeight + MEDIA_STAGE_EXTRA_HEIGHT : null;

    useEffect(() => {
        setActiveMediaIndex(0);
    }, [item]);

    useEffect(() => {
        if (mediaItems.length < 2) return undefined;

        const interval = window.setInterval(() => {
            setActiveMediaIndex((currentIndex) => (currentIndex + 1) % mediaItems.length);
        }, MEDIA_CAROUSEL_DELAY);

        return () => window.clearInterval(interval);
    }, [mediaItems.length]);

    useEffect(() => {
        const setMatchedMediaHeight = () => {
            if (!contentRef.current) return;

            setMediaHeight(contentRef.current.offsetHeight);
        };
        const contentElement = contentRef.current;
        const resizeObserver = window.ResizeObserver && contentElement
            ? new ResizeObserver(setMatchedMediaHeight)
            : null;

        setMatchedMediaHeight();
        resizeObserver?.observe(contentElement);
        window.addEventListener('resize', setMatchedMediaHeight);
        window.addEventListener('load', setMatchedMediaHeight);

        return () => {
            resizeObserver?.disconnect();
            window.removeEventListener('resize', setMatchedMediaHeight);
            window.removeEventListener('load', setMatchedMediaHeight);
        };
    }, [item]);

    const renderMedia = () => {
        if (mediaType === 'video') {
            return (
                <video
                    className="slider-media"
                    src={mediaSrc}
                    title={item.title}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="metadata"
                />
            );
        }

        return <img className="slider-media" src={mediaSrc} alt={item.title} />;
    };

    // const [modalShow, setModalShow] = useState(false);

    return (
        <div className={`box-slider ${item.classAction || ''}`}>
            <div className="box-slider__main">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-md-12">
                            <div
                                className="content-box"
                                style={mediaStageHeight ? { minHeight: `${mediaStageHeight}px` } : undefined}
                            >
                                <div className="content-box__inner" ref={contentRef}>
                                    <p className="eyebrow">{item.eyebrow}</p>
                                    <h1 className="title">{item.title}</h1>
                                    <p className="sub-title">{item.desc}</p>
                                    <div className="wrap-btn">
                                        <a className="bp-button bp-button--primary" href="https://www.satflow.com/ordinals/blockpirates" target="_blank" rel="noreferrer">View on Satflaw</a>
                                        <a className="bp-button bp-button--ghost" href="https://twitter.com/Block_Pirates" target="_blank" rel="noreferrer">Follow Updates</a>
                                    </div>
                                    <div className="hero-stats" aria-label="Collection stats">
                                        <div><strong>10K</strong><span>Supply</span></div>
                                        <div><strong>232</strong><span>Traits</span></div>
                                        <div><strong>31</strong><span>Categories</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-md-12">
                            <div
                                className={`image media-stage media-stage--${mediaType} ${mediaFitClass}`}
                                style={mediaStageHeight ? { height: `${mediaStageHeight}px` } : undefined}
                            >
                                <div className="media-transition-shell" key={mediaSrc}>
                                    {renderMedia()}
                                    <span className="ripple-transition" aria-hidden="true">
                                        {Array.from({ length: MEDIA_RIPPLE_COUNT }, (_, index) => (
                                            <span key={index} />
                                        ))}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <Modal
                show={modalShow}
                onHide={setModalShow}
            >
            <Modal.Header closeButton></Modal.Header>

                <div className="modal-body center">
                                <div className="box-wallet-inner">
                                    <div className="sc-box">
                                        <div className="img">
                                            <img src="assets/images/common/icon-1.png" alt="Crybox" />
                                        </div>
                                        <h6 className="heading"><a href="#">Meta Mask</a> </h6>
                                        <p className="content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt</p>
                                    </div>
                                    <div className="sc-box">
                                        <div className="img">
                                            <img src="assets/images/common/icon-6.png" alt="Crybox" />
                                        </div>
                                        <h6 className="heading"><a href="#"> Bitski</a></h6>
                                        <p className="content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt</p>
                                    </div>
                                    <div className="sc-box">
                                        <div className="img">
                                            <img src="assets/images/common/vector.png" alt="Crybox" />
                                        </div>
                                        <h6 className="heading"><a href="#">Fortmatic</a> </h6>
                                        <p className="content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt</p>
                                    </div>
                                    <div className="sc-box">
                                        <div className="img">
                                            <img src="assets/images/common/icon-2.png" alt="Crybox" />
                                        </div>
                                        <h6 className="heading"><a href="#">Coinbase Wallet</a> </h6>
                                        <p className="content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt</p>
                                    </div>
                                    <div className="sc-box">
                                        <div className="img">
                                            <img src="assets/images/common/icon-3.png" alt="Crybox" />
                                        </div>
                                        <h6 className="heading"><a href="#">Authereum</a> </h6>
                                        <p className="content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt</p>
                                    </div>
                                    <div className="sc-box">
                                        <div className="img">
                                            <img src="assets/images/common/icon-4.png" alt="Crybox" />
                                        </div>
                                        <h6 className="heading"><a href="#">Kaikas</a> </h6>
                                        <p className="content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt</p>
                                    </div>
                                </div>  
                            </div>
            </Modal> */}

            {/* <div className="modal fade popup" id="popup_bid" tabindex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="header-popup">
                        <h5>Connect to a wallet</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    
                    
                </div>
            </div>
        </div> */}
        </div>
    );
}

export default SliderItem;


//button algorythm between lines 34 and 38 

/*

<button to="#" className="tf-button btn-effect popup-youtube" onClick={()=> setOpen(false)}>
                                    
                                       
<span className="boder-fade"></span>                                     
<span className="effect">Mint Here</span>

</button>*/


///// Connect wallet button can be redeployed to line 33

//  <Link to="#" className="tf-button-st2 btn-effect" data-toggle="modal" data-target="#popup_bid"><span className="effect">connect wallet</span></Link>
